export * from './infoBox.component';
